import { createApp } from 'vue'
import Loading from './components/Loading'

/**
 * 创建加载窗口
 * 
 * @param  string  message
 * @return function  destroy
 */
function createLoading(message = '')
{
    const instance = createApp(Loading, {
        message
    })
    const mountDom = document.createElement('div');
    document.body.appendChild(mountDom);
    instance.mount(mountDom);
    return function () {
        instance.unmount(mountDom);
        document.body.removeChild(mountDom);
    };
}

export {
    createLoading
}